import { Col, Form, Row } from "react-bootstrap";
import { ClientGeneralParams } from "../../types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import '../GeneralParams.css'

interface CampaignAndSurveyParamsFormProp {
    updateField: (field: keyof ClientGeneralParams, value: any) => void
}

export default function CampaignAndSurveyParamsForm({ updateField }: CampaignAndSurveyParamsFormProp) {
    const { t } = useTranslation(['clientParams']);
    const clientParams = useSelector((state: RootState) => state.clientParamsForm.data);
    const errors = useSelector((state: RootState) => state.clientParamsForm.errors);

    return (
        <Form>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column md={6}>{t("clientParams:form.campaignSurveysSendingTimeLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:text")}</Form.Label>
                    <Form.Control
                        value={clientParams.campaignSurveysSendingTime ?? ""}
                        onChange={(e) => updateField("campaignSurveysSendingTime", e.target.value)}
                        isInvalid={!!errors?.campaignSurveysSendingTime}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.campaignSurveysSendingTime}
                    </Form.Control.Feedback>                        
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column md={6}>{t("clientParams:form.campaignSurveysEmailSubjectLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:text")}</Form.Label>
                    <Form.Control
                        value={clientParams.campaignSurveysEmailSubject ?? ""}
                        onChange={(e) => updateField("campaignSurveysEmailSubject", e.target.value)}
                        isInvalid={!!errors?.campaignSurveysEmailSubject}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.campaignSurveysEmailSubject}
                    </Form.Control.Feedback>                        
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column md={6}>{t("clientParams:form.campaignSurveysEmailBodyLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:text")}</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={5}
                        value={clientParams.campaignSurveysEmailBody ?? ""}
                        onChange={(e) => updateField("campaignSurveysEmailBody", e.target.value)}
                        isInvalid={!!errors?.campaignSurveysEmailBody}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.campaignSurveysEmailBody}
                    </Form.Control.Feedback>                        
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column md={6}>{t("clientParams:form.campaignSurveysSmsBodyLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:text")}</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={5}
                        value={clientParams.campaignSurveysSmsBody ?? ""}
                        onChange={(e) => updateField("campaignSurveysSmsBody", e.target.value)}
                        isInvalid={!!errors?.campaignSurveysSmsBody}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.campaignSurveysSmsBody}
                    </Form.Control.Feedback>                        
                </Col>
            </Form.Group>
        </Form>
    );
}